import { render } from "./2022-11-01-Webpack Base Description.md?vue&type=template&id=5faa8756"
const script = {}
script.render = render

export default script